import { css, type Theme } from '@emotion/react';

export const headingTypography = (theme: Theme) => css`
  font-family: 'Inter Tight Variable', sans-serif;
  color: ${theme.text.heading};
`;

export const cardTitleTypography = (theme: Theme) => css`
  color: ${theme.text.heading};
  font-size: 18px;
  font-weight: 600;
  line-height: 1.3;
`;
